import React from "react";
import { FileText } from "lucide-react";
import { fileUrl } from "@/components/erp/prod/ProdInputs";
import { filamentsOf } from "@/components/erp/prod/JobFormModal";

const fmtMin = (m) => `${Math.floor((m || 0) / 60)}j ${Math.round((m || 0) % 60)}m`;
const Cell = ({ k, v, tid }) => <div><div className="text-[10px] text-slate-500">{k}</div><div className="text-sm font-semibold" data-testid={tid}>{v}</div></div>;

// Data dari Kepala Data untuk Operator (lihat saja, tanpa download)
export const JobPreview = ({ job, machines = [] }) => {
  if (!job) return null;
  const fl = filamentsOf(job);
  const plan = machines.find((m) => m.id === job.planned_machine_id);
  return (
    <div className="rounded-xl border border-slate-200 p-3 space-y-3 bg-slate-50/60" data-testid="job-preview">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <FileText className="w-4 h-4 text-slate-500" /><b>{job.file_name}</b>
        {job.group_name && <span className="text-[10px] px-1.5 rounded bg-indigo-100 text-indigo-700">{job.group_name}</span>}
        {job.revision > 0 && <span className="text-[10px] px-1.5 rounded bg-violet-100 text-violet-700">{job.revision_kind === "SUSULAN" ? "File Tertinggal" : "Revisi"} {job.revision}</span>}
        <span className="text-[11px] text-slate-500" data-testid="job-preview-file">{job.prod_file_name ? `${job.prod_file_name}${job.prod_file_size ? ` · ${(job.prod_file_size / 1048576).toFixed(1)} MB` : ""} (ambil dari Kepala Data)` : "tanpa file"}</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        <Cell k="Durasi/jalan" v={fmtMin(job.duration_min)} tid="job-preview-duration" />
        <Cell k="Qty/jalan" v={`${job.qty_planned} pcs`} tid="job-preview-qty" />
        <Cell k="Total" v={`${job.qty_total || job.qty_planned} pcs`} tid="job-preview-total" />
        <Cell k="Kali jalan" v={job.runs_total || 1} tid="job-preview-runs" />
        <Cell k="Berat/jalan" v={`${Math.round(job.weight_plan_g || 0)} g`} tid="job-preview-weight" />
        <Cell k="Plan mesin" v={plan?.name || "bebas"} tid="job-preview-machine" />
      </div>
      <div>
        <div className="text-[10px] text-slate-500 mb-1">Filament per file</div>
        {fl.map((f, k) => <div key={k} className="text-sm" data-testid={`job-preview-fil-${k}`}>F{k + 1} · {f.material} · <b>{f.color || "—"}</b> · {Math.round(f.weight_g || 0)} g/jalan</div>)}
        {!fl.length && <div className="text-sm text-slate-400">—</div>}
      </div>
      {job.wo_notes && <div className="text-sm rounded-lg bg-amber-50 border border-amber-200 text-amber-900 px-2 py-1" data-testid="job-preview-wo-notes"><b>Catatan customer:</b> {job.wo_notes}</div>}
      {job.head_note && <div className="text-sm italic text-slate-700" data-testid="job-preview-note">“{job.head_note}”</div>}
      {!job.preview_images?.length && <div className="text-xs text-slate-400" data-testid="job-preview-no-images">Kepala Data belum melampirkan gambar bentuk benda.</div>}
      {job.preview_images?.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="job-preview-images">
          {job.preview_images.map((p) => <img key={p} src={fileUrl(p)} alt="preview" onContextMenu={(e) => e.preventDefault()} draggable={false} className="h-28 rounded-lg border object-contain bg-white" />)}
        </div>
      )}
    </div>
  );
};
